import React from "react";
import PropTypes from "prop-types";
import { Link, graphql, StaticQuery } from "gatsby";
//import PreviewCompatibleImage from "./PreviewCompatibleImage";
import careersStyles from "./CareersRoll.module.scss";

class CareersRoll extends React.Component {
  render() {
    const { data } = this.props;
    const { edges: posts } = data.allMarkdownRemark;

    return (
      <div>
        {posts &&
          posts.map(({ node: post }) => (
            <div className="max-w-5xl pb-24" key={post.id}>
              <article
              /*    className={`careers-list-item tile is-child box notification ${
                  post.frontmatter.featuredpost ? "is-featured" : ""
                }`} */
              >
                <header>
                  {/*       {post.frontmatter.featuredimage ? (
                    <div className="featured-thumbnail">
                      <PreviewCompatibleImage
                        imageInfo={{
                          image: post.frontmatter.featuredimage,
                          alt: `featured image thumbnail for post ${post.frontmatter.title}`,
                        }}
                      />
                    </div>
                      ) : null} */}
                  <div className="block border-b border-gray-300 py-12 relative w-full">
                    <Link to={post.fields.slug} className={careersStyles.careersHover + " focus:outline-none lg:flex lg:justify-between"}>
                      <div className="lg:max-w-sm md:mr-8">
                        <h2 className="font-serif font-medium inline text-indigo-800 pr-1 font-semibold lg:mb-6 mb-2 md:text-3xl text-gray-900 text-xl">{post.frontmatter.title}</h2>
                        <div className="inline-flex items-center text-sm text-gray-800">
                          <p>Posted: {post.frontmatter.date}</p>
                          {/* <p className="mx-1 md:mx-2 text-indigo-600 text-xl">·</p>
                          <p>{post.frontmatter.author}</p> */}
                        </div>
                      </div>
                      <div className="lg:max-w-lg lg:mr-6 w-11/12">
                        <p className="md:leading-relaxed lg:mt-0 mt-4 text-gray-800 md:text-lg">{post.excerpt}</p>
                        <div className="mt-6 inline-flex items-center">
                        <a class="border-2 border-blue-300 focus:bg-blue-300 focus:outline-none font-medium hover:bg-blue-300 py-4 px-6 rounded-full text-indigo-900" href={post.fields.slug} rel="noopener noreferrer" target="_blank">Learn more</a>
                        </div>
                      </div>
                    </Link>
                  </div>
                </header>
              </article>
            </div>
          ))}
      </div>
    );
  }
}

CareersRoll.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.array,
    }),
  }),
};

export default () => (
  <StaticQuery
    query={graphql`
      query CareersRollQuery {
        allMarkdownRemark(
          sort: { order: DESC, fields: [frontmatter___date] }
          filter: { frontmatter: { templateKey: { eq: "careers-post" } } }
        ) {
          edges {
            node {
              excerpt(pruneLength: 200)
              id
              fields {
                slug
              }
              frontmatter {
                title
                author
                templateKey
                date(formatString: "MMMM DD, YYYY")
              }
            }
          }
        }
      }
    `}
    render={(data, count) => <CareersRoll data={data} count={count} />}
  />
);
